module.exports = __webpack_public_path__ + "img/service_guide_step3.397d40b.png";